import React, { useEffect, useState } from 'react'
import DialogWrapper from '../../../components/core-ui/DialogWrapper'
import { fieldTemplateService } from '../../../services/fieldTemplateService'
import { useAuthContext } from '../../../hooks/useAuthContext'
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  FormControl,
  TextField,
  Typography,
} from '@mui/material'
import adminFieldService from '../../../services/admin/field'
import { toast } from 'react-toastify'

const DerivePageDialog = ({
  open,
  setOpen,
  pageId = null,
  activityTemplateId,
  processTemplateId,
  onDeriveSuccess,
}) => {
  const { user } = useAuthContext()
  const [fields, setFields] = useState([])
  const [allActivities, setAllActivities] = useState([])
  const [allPages, setAllPages] = useState([])
  const [selectedActivity, setSelectedActivity] = useState(null)
  const [derivingData, setDerivingData] = useState([])

  useEffect(() => {
    ;(async () => {
      if (open) {
        const derivableFields = await fieldTemplateService.getDerivableFieldsForProcess(
          user,
          processTemplateId
        )
        setFields(derivableFields)

        console.log('xxx derivableFields', derivableFields)

        // get all activities
        const activities = derivableFields.reduce((acc, cur) => {
          const activity = acc?.find((it) => it.id == cur.activity_template_id)
          if (!activity) {
            return [
              ...acc,
              {
                id: cur.activity_template_id,
                activity_template_name: cur.activity_template_name,
                sequence: cur.activity_sequence,
              },
            ]
          }
          return acc
        }, [])
        setAllActivities(activities.filter((it) => it.id != activityTemplateId))

        // get all pages
        const pages = derivableFields.reduce((acc, cur) => {
          const page = acc?.find((it) => it.id == cur.page_template_id)
          if (!page) {
            return [
              ...acc,
              {
                id: cur.page_template_id,
                page_template_name: cur.page_template_name,
                sequence: cur.page_sequence,
                activity_template_id: cur.activity_template_id,
              },
            ]
          }
          return acc
        }, [])
        setAllPages(pages)
      }
    })()
  }, [open])

  const derivePageWithFields = async () => {
    try {
      // call derive api
      await adminFieldService.deriveFieldsWithPages(user, activityTemplateId, {
        data: derivingData,
        page_id: pageId,
      })
      setOpen(false)
      onDeriveSuccess()
      toast.success('Page with fields derived successfully')
    } catch (error) {
      toast.error('Something went wrong!')
    }
  }

  return (
    <DialogWrapper open={open} onClose={() => setOpen(false)} heading={'Derive Pages & Fields'}>
      <Box>
        {/* select activity */}
        <FormControl
          variant="outlined"
          fullWidth
          size="small"
          color="primary"
          style={{ minWidth: 300 }}
        >
          <Autocomplete
            id="select-derived-field"
            options={allActivities}
            size="small"
            getOptionLabel={(item) => item?.activity_template_name}
            value={selectedActivity}
            onChange={(_, v) => setSelectedActivity(v)}
            renderInput={(params) => (
              <TextField {...params} variant="outlined" label="Select Activity" color="primary" />
            )}
          />
        </FormControl>

        {/* select page */}
        {allPages
          .filter((it) => it.activity_template_id == selectedActivity?.id)
          .map((page) => {
            return (
              <Box>
                <Checkbox
                  color="primary"
                  checked={
                    derivingData.find((it) => it.page_id == page.id) != undefined && pageId == null
                  }
                  disabled={pageId != null}
                  onChange={() => {
                    if (derivingData.find((it) => it.page_id == page.id) != undefined) {
                      setDerivingData(derivingData.filter((it) => it.page_id != page.id))
                    } else {
                      setDerivingData([
                        ...derivingData,
                        {
                          page_id: page.id,
                          field_ids: fields
                            .filter((it) => it.page_template_id == page.id)
                            .map((it) => it.id),
                        },
                      ])
                    }
                  }}
                />
                <Typography variant="p">{page.page_template_name}</Typography>
                {derivingData.find((it) => it.page_id == page.id) != undefined || pageId != null ? (
                  <Box>
                    {fields
                      .filter(
                        (it) =>
                          it.page_template_id == page.id && !it.is_subfield && !it.is_derived_field
                      )
                      .map((field) => {
                        const data = derivingData?.find((it) => it.page_id == page.id)
                        return (
                          <Box style={{ marginLeft: 24 }}>
                            <Checkbox
                              color="primary"
                              checked={data?.field_ids?.includes(field.id)}
                              onChange={() => {
                                if (data) {
                                  if (data.field_ids?.includes(field.id)) {
                                    data.field_ids = data?.field_ids?.filter((it) => it != field.id)
                                    setDerivingData(
                                      derivingData.map((it) => (it.page_id == page.id ? data : it))
                                    )
                                  } else {
                                    data.field_ids = [...data.field_ids, field.id]
                                    setDerivingData(
                                      derivingData.map((it) => (it.page_id == page.id ? data : it))
                                    )
                                  }
                                } else {
                                  setDerivingData([
                                    ...derivingData,
                                    { page_id: page.id, field_ids: [field.id] },
                                  ])
                                }
                              }}
                            />
                            <Typography variant="p">{field.field_template_name}</Typography>
                          </Box>
                        )
                      })}
                  </Box>
                ) : null}
              </Box>
            )
          })}
        <Box
          style={{
            display: 'flex',
            columnGap: 16,
            width: '100%',
            justifyContent: 'flex-end',
            marginTop: 16,
          }}
        >
          <Button variant="contained" onClick={() => setOpen(false)}>
            Cancel
          </Button>
          <Button color="primary" variant="contained" onClick={derivePageWithFields}>
            Save
          </Button>
        </Box>
      </Box>
    </DialogWrapper>
  )
}

export default DerivePageDialog
